export var SourceEventTypeEnum;
(function (SourceEventTypeEnum) {
    SourceEventTypeEnum["NEW_MESSAGE"] = "new_message";
    SourceEventTypeEnum["END_EVENT"] = "end_event";
})(SourceEventTypeEnum || (SourceEventTypeEnum = {}));
